module.exports = __webpack_public_path__ + "img/clipboard-list-solid.d73ead14.svg";